import React from "react";
import { Box, Grid, GridItem, Text, VStack } from "@chakra-ui/react";
import Num from "../common/Num";               // ⬅️  formatter comune

export default function PeriodicitySelector({
  periodicities = [],
  selected      = null,
  onSelect      = () => {},
}) {
  return (
    <Box mb={8}>
      <Text mb={2}>2. Seleziona Periodicità</Text>

      <Grid templateColumns="repeat(auto-fill, minmax(140px, 1fr))" gap={4}>
        {periodicities
          .filter(p => p.duration_months >= 6 && p.duration_months <= 36)
          .sort((a, b) => a.duration_months - b.duration_months)
          .map(p => (
            <GridItem
              key={p.id}
              p={4}
              cursor="pointer"
              border="1px solid"
              borderColor={selected?.id === p.id ? "blue.400" : "gray.200"}
              borderRadius="md"
              onClick={() => onSelect(p)}
              _hover={{ boxShadow: "sm" }}
            >
              <VStack spacing={1}>
                {/* titolo */}
                <Text fontSize="sm" fontWeight="bold">
                  {p.title}
                </Text>

                {/* durata in mesi */}
                <Text fontSize="sm">
                  <Num value={p.duration_months} fmt="int" /> mesi
                </Text>

                {/* sconto / sovrapprezzo in % */}
                <Text fontSize="sm">
                  {/* se è ≥0 anteponiamo “+”, altrimenti il Num formatterà col segno “–” */}
                  {p.discount >= 0 ? "+" : ""}
                  <Num value={p.discount} fmt="%" />
                </Text>
              </VStack>
            </GridItem>
          ))}
      </Grid>
    </Box>
  );
}
